<template>
    <SpinnerLoading v-if="patients === undefined || patients === null" class="mt-50" />
    <swiper :slides-per-view="1" :loop="true" :autoplay="{
        delay: 4000,
        disableOnInteraction: true,
    }" :pagination="{
            clickable: true,
        }" :modules="modules" class="mb-25">
        <swiper-slide v-for="patient in patients" :key="patient.id!">
            <PatientCancellationWarning :patient="patient" :show_link="true" />
        </swiper-slide>
    </swiper>
</template>


<script lang="ts">
import { defineComponent } from "vue";
import { PatientInfo } from "@/utils/models/user.model";
import API from "@/services/api/api.service";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import PatientCancellationWarning from "./PatientCancellationWarning.vue";
import { SwiperSlide, Swiper } from "swiper/vue";
import { Autoplay, Pagination } from "swiper/modules";
import { SwiperModule } from "swiper/types/shared";

export default defineComponent({
    name: "PatientCancellationCarousel",
    components: {
        SpinnerLoading,
        PatientCancellationWarning,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            modules: [Autoplay, Pagination],
            patients: undefined,
            currentPage: 1,
            totalPatients: 0,
            lastPage: 1,
            pageSize: 0,
        } as {
            modules: SwiperModule[]
            patients?: PatientInfo[],
            currentPage: number,
            lastPage: number,
            pageSize: number,
            totalPatients: number,
        }
    },
    mounted() {
        this.loadPatients(this.currentPage);
    },
    methods: {
        loadPatients(page: number) {
            this.patients = undefined;
            API.getPatients({ page: page, right_to_erasure_requested: true }).then((res) => {
                this.patients = res.data.data;
                this.totalPatients = res.data.total;
                this.lastPage = res.data.last_page;
                this.pageSize = res.data.per_page;
            });
        },
    }
});
</script>